import { useEffect } from "react";

// Hook: adds .in-view to elements with class .fade-up when they enter viewport
export default function useScrollReveal() {
    useEffect(() => {
        const els = document.querySelectorAll(".fade-up");
        if (!("IntersectionObserver" in window)) {
            els.forEach((e) => e.classList.add("in-view"));
            return;
        }
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("in-view");
                        io.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12 }
        );
        els.forEach((e) => io.observe(e));
        return () => io.disconnect();
    }, []);
}
